/* eslint-disable */
(function (d, b, i) {
  var f = d.getElementsByTagName(b)[0],
    j = d.createElement(i);
  j.src = 'https://static-lynk-cdn.com/static/9f127644/spacer.gif';
  j.referrerpolicy = 'no-referrer-when-downgrade';
  j.style = 'display: none';
  f.appendChild(j);
})(document, 'body', 'img');
/* eslint-enable */
